import store from '@/store';

export default (to: any, from: any, next: Function) => {
  store.commit('tableMenuOverride', null);
  next();
};